export default value => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0)
}
